<div>
  <div *ngIf="showTab" class="p-4 mt-3 card_style_bs_order_cat">
    <div class="card card-body">
      <h5 class="card-title title_header_0">
        Complete Your Process in Just 2 Easy Steps
      </h5>
      <div class="d-flex">
        <ul class="row steps_style box_cat_upload">
          <li
            [ngClass]="[
              active_product ? 'box-item_active' : '',
              showUploadDocuments ? 'boxOutline' : 'box-item'
            ]"
            class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          >
            1. Upload documents
          </li>

          <li
            [ngClass]="[
              active_confirm ? 'box-item_active' : '',
              showConfirmation ? 'boxOutline' : 'box-item'
            ]"
            class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
          >
            2. Order confirmation
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div *ngIf="showEsignTab" class="p-4">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>E-Sign</span>
        </p>
      </div>
    </div>

    <div class="card mx-4 mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 3 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Upload documents
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. Signing details
            </li>

            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="p-4 mt-3">
      <div class="card card-body">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-md-6">
            <h5 class="title_five">Order Confirmation</h5>
            <div style="margin-top: 1rem">
              <div *ngIf="placedOrderDetails?.order_type === 'ESTAMP'">
                <ul class="order_con">
                  <li>
                    <span class="bullet"></span>Your order request has been
                    placed <span class="order_bold">successfully!</span>
                  </li>

                  <li *ngIf="eStampData.length != 0">
                    <span class="bullet"></span>
                    E-Stamp orders have been initiated.
                  </li>
                  <li *ngIf="isBulk">
                    <span class="bullet"></span> The order details for the bulk
                    order can be viewed on the Bulk Order Details page
                  </li>
                  <li>
                    <span class="bullet"></span>Once completed, you will receive
                    an email confirmation.
                  </li>
                  <li>
                    <span class="bullet"></span> You can download the final
                    document from the order details page once it is completed.
                  </li>
                </ul>
              </div>
              <div *ngIf="placedOrderDetails?.order_type === 'ESIGN'">
                <ul class="order_con">
                  <li>
                    <span class="bullet"></span>Your order request has been
                    placed <span class="order_bold">successfully!</span>
                  </li>
                  <li *ngIf="eSignData.length != 0">
                    <span class="bullet"></span>
                    The Email E-Sign Link will be sent to the following email :
                    <span *ngFor="let sign of eSignData" class="m-1"
                      ><b>{{ sign.email }}</b></span
                    >
                  </li>
                  <li *ngIf="isBulk">
                    <span class="bullet"></span> The order details for the bulk
                    order can be viewed on the Bulk Order Details page
                  </li>
                  <li>
                    <span class="bullet"></span>Once completed you will get
                    email confirmation
                  </li>
                  <li>
                    <span class="bullet"></span> You can download the final
                    document from the order details page once it is Completed.
                  </li>
                </ul>
              </div>
              <div
                *ngIf="
                  placedOrderDetails?.order_type === 'CAT_UPLOAD' ||
                  placedOrderDetails?.order_type === 'CAT_COMPOSE'
                "
              >
                <ul class="order_con">
                  <li>
                    <span class="bullet"></span>Your order request has been
                    placed <span class="order_bold">successfully!</span>
                  </li>

                  <li *ngIf="eStampData.length != 0">
                    <span class="bullet"></span> The E-Stamp orders have been
                    initiated.
                  </li>

                  <li *ngIf="eSignData.length != 0">
                    <span class="bullet"></span>
                    The Email E-Sign Link will be sent to the following email :
                    <span *ngFor="let sign of eSignData" class="m-1"
                      ><b>{{ sign.email }}</b></span
                    >
                  </li>
                  <li *ngIf="isBulk">
                    <span class="bullet"></span>The order details for the bulk
                    order can be viewed on the Bulk Order Details page
                  </li>
                  <li>
                    <span class="bullet"></span>Once completed you will get
                    email confirmation
                  </li>
                  <li>
                    <span class="bullet"></span> You can download the final
                    document from the order details page once it is Completed.
                  </li>
                </ul>
              </div>
              <div *ngIf="placedOrderDetails?.order_type === 'CAT_EDIT'">
                <ul class="order_con">
                  <li>
                    <span class="bullet"></span>Your order request has been
                    placed <span class="order_bold">successfully!</span>
                  </li>

                  <li *ngIf="eStampData.length != 0">
                    <span class="bullet"></span>
                    The E-Stamp orders have been initiated.
                  </li>

                  <li *ngIf="eSignData.length != 0">
                    <span class="bullet"></span>
                    The Email E-Sign Link will be sent to the following email :
                    <span *ngFor="let sign of eSignData" class="m-1"
                      ><b>{{ sign.email }}</b></span
                    >
                  </li>
                  <li *ngIf="isBulk">
                    <span class="bullet"></span> The order details for the bulk
                    order can be viewed on the Bulk Order Details page
                  </li>
                  <li>
                    <span class="bullet"></span>You can view the edited document
                    in view details Screen
                  </li>
                  <li>
                    <span class="bullet"></span>Once completed you will get
                    email confirmation
                  </li>
                  <li>
                    <span class="bullet"></span> You can download the final
                    document from the order details page once it is Completed.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-1 col-sm-1 col-md-1 vertical_style"></div>
          <div class="col-lg-6 col-sm-6 col-md-6">
            <div class="row">
              <h5 class="card-title title_header_0">Order Details:</h5>
            </div>

            <div class="flex_row">
              <div class="col-3">
                <span class="form_field"> Order Number :</span>
              </div>
              <div class="col-2">
                <span class="order_con_value">
                  {{ placedOrderDetails?.id }}</span
                >
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Service :</span>
              </div>
              <div class="col-2">
                <span class="order_con_value">
                  {{ placedOrderDetails?.order_type }}</span
                >
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field"> Date :</span>
              </div>
              <div class="col-2">
                <span class="order_con_value">
                  {{ placedOrderDetails?.created | date }}</span
                >
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field"> Order Status :</span>
              </div>
              <div class="col-3">
                <span class="order_con_value">{{
                  placedOrderDetails?.status === "WAITING_FOR_APPROVAL"
                    ? "Approval Pending"
                    : placedOrderDetails?.status_display
                }}</span>
              </div>
            </div>
            <div class="text-right custom_button mt-3">
              <p-button
                label="Order List"
                (click)="goToOrdersPage(placedOrderDetails)"
                styleClass="p-button-sm-outline"
              ></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showCatUpload" class="p-4">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Cat-Upload</span>
        </p>
      </div>
    </div>

    <div class="card mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 4 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Upload documents
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. E-stamp details
            </li>
            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. E-sign details
            </li>

            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showCatImport" class="p-4">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Cat-Import</span>
        </p>
      </div>
    </div>

    <div class="card mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 2 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Upload documents
            </li>
            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showCatCompose" class="p-4">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Cat-Compose</span>
        </p>
      </div>
    </div>

    <div class="card mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 4 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Upload documents
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. E-stamp details
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. Signing details
            </li>

            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              4. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showCatEdit" class="p-4">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Cat-Edit</span>
        </p>
      </div>
    </div>

    <div class="card mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 5 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Select Template
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. Edit Template
            </li>
            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. E-stamp Details
            </li>
            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              4. Signing details
            </li>

            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              5. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!showEsignTab && !showCatImport && !showBulkEstamp"
    class="p-4 mt-3"
  >
    <div class="card card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Order Confirmation</h5>
          <div style="margin-top: 1rem">
            <div *ngIf="placedOrderDetails?.order_type === 'ESTAMP'">
              <ul class="order_con">
                <li>
                  <span class="bullet"></span>Your order request has been placed
                  <span class="order_bold">successfully!</span>
                </li>

                <li *ngIf="eStampData.length != 0">
                  <span class="bullet"></span>
                  E-Stamp orders have been initiated.
                </li>
                <li *ngIf="isBulk">
                  <span class="bullet"></span> The order details for the bulk
                  order can be viewed on the Bulk Order Details page
                </li>
                <li>
                  <span class="bullet"></span>Once completed, you will receive
                  an email confirmation.
                </li>
                <li>
                  <span class="bullet"></span> You can download the final
                  document from the order details page once it is completed.
                </li>
              </ul>
            </div>
            <div *ngIf="placedOrderDetails?.order_type === 'ESIGN'">
              <ul class="order_con">
                <li>
                  <span class="bullet"></span>Your order request has been placed
                  <span class="order_bold">successfully!</span>
                </li>
                <li *ngIf="eSignData.length != 0">
                  <span class="bullet"></span>
                  The Email E-Sign Link will be sent to the following email :
                  <span *ngFor="let sign of eSignData" class="m-1"
                    ><b>{{ sign.email }}</b></span
                  >
                </li>
                <li *ngIf="isBulk">
                  <span class="bullet"></span> The order details for the bulk
                  order can be viewed on the Bulk Order Details page
                </li>
                <li>
                  <span class="bullet"></span>Once completed you will get email
                  confirmation
                </li>
                <li>
                  <span class="bullet"></span> You can download the final
                  document from the order details page once it is Completed.
                </li>
              </ul>
            </div>
            <div
              *ngIf="
                placedOrderDetails?.order_type === 'CAT_UPLOAD' ||
                placedOrderDetails?.order_type === 'CAT_COMPOSE'
              "
            >
              <ul class="order_con">
                <li>
                  <span class="bullet"></span>Your order request has been placed
                  <span class="order_bold">successfully!</span>
                </li>

                <li *ngIf="eStampData.length != 0">
                  <span class="bullet"></span> The E-Stamp orders have been
                  initiated.
                </li>

                <li *ngIf="eSignData.length != 0">
                  <span class="bullet"></span>
                  The Email E-Sign Link will be sent to the following email :
                  <span *ngFor="let sign of eSignData" class="m-1"
                    ><b>{{ sign.email }}</b></span
                  >
                </li>
                <li *ngIf="isBulk">
                  <span class="bullet"></span>The order details for the bulk
                  order can be viewed on the Bulk Order Details page
                </li>
                <li>
                  <span class="bullet"></span>Once completed you will get email
                  confirmation
                </li>
                <li>
                  <span class="bullet"></span> You can download the final
                  document from the order details page once it is Completed.
                </li>
              </ul>
            </div>
            <div *ngIf="placedOrderDetails?.order_type === 'CAT_EDIT'">
              <ul class="order_con">
                <li>
                  <span class="bullet"></span>Your order request has been placed
                  <span class="order_bold">successfully!</span>
                </li>

                <li *ngIf="eStampData.length != 0">
                  <span class="bullet"></span>
                  The E-Stamp orders have been initiated.
                </li>

                <li *ngIf="eSignData.length != 0">
                  <span class="bullet"></span>
                  The Email E-Sign Link will be sent to the following email :
                  <span *ngFor="let sign of eSignData" class="m-1"
                    ><b>{{ sign.email }}</b></span
                  >
                </li>
                <li *ngIf="isBulk">
                  <span class="bullet"></span> The order details for the bulk
                  order can be viewed on the Bulk Order Details page
                </li>
                <li>
                  <span class="bullet"></span>You can view the edited document
                  in view details Screen
                </li>
                <li>
                  <span class="bullet"></span>Once completed you will get email
                  confirmation
                </li>
                <li>
                  <span class="bullet"></span> You can download the final
                  document from the order details page once it is Completed.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-sm-1 col-md-1 vertical_style"></div>
        <div class="col-lg-6 col-sm-6 col-md-6">
          <div class="row">
            <h5 class="card-title title_header_0">Order Details:</h5>
          </div>

          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Order Number :</span>
            </div>
            <div class="col-2">
              <span class="order_con_value"> {{ placedOrderDetails?.id }}</span>
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field">Service :</span>
            </div>
            <div class="col-2">
              <span class="order_con_value">
                {{ placedOrderDetails?.order_type }}</span
              >
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Date :</span>
            </div>
            <div class="col-2">
              <span class="order_con_value">
                {{ placedOrderDetails?.created | date }}</span
              >
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Order Status :</span>
            </div>
            <div class="col-3">
              <span class="order_con_value">{{
                placedOrderDetails?.status === "WAITING_FOR_APPROVAL"
                  ? "Approval Pending"
                  : placedOrderDetails?.status_display
              }}</span>
            </div>
          </div>
          <div class="text-right custom_button mt-3">
            <p-button
              label="Order List"
              (click)="goToOrdersPage(placedOrderDetails)"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showCatImport" class="mt-3">
    <div class="card card-body">
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Order Confirmation</h5>
          <div style="margin-top: 1rem">
            <div>
              <ul class="order_con">
                <li>
                  <span class="bullet"></span>Your document has been imported
                  <span class="order_bold">successfully!</span>
                </li>
                <li>
                  <span class="bullet"></span> You can view the document in the
                  view details screen.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-sm-1 col-md-1 vertical_style"></div>
        <div class="col-lg-6 col-sm-6 col-md-6">
          <div class="row">
            <h5 class="card-title title_header_0">Order Details:</h5>
          </div>

          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Order Number :</span>
            </div>
            <div class="col-2" *ngIf="!showCatImport">
              <span class="order_con_value"> {{ placedOrderDetails?.id }}</span>
            </div>
            <div class="col-2" *ngIf="showCatImport">
              <span class="order_con_value">
                <ng-container *ngIf="orderIds.length > 0; else singleId">
                  <div *ngFor="let id of orderIds">{{ id }}</div>
                </ng-container>
                <ng-template #singleId>
                  {{ placedOrderDetails?.id }}
                </ng-template>
              </span>
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field">Service :</span>
            </div>
            <div class="col-2">
              <span class="order_con_value">
                {{ placedOrderDetails?.order_type }}</span
              >
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Date :</span>
            </div>
            <div class="col-2">
              <span class="order_con_value">
                {{ placedOrderDetails?.created | date }}</span
              >
            </div>
          </div>
          <div class="flex_row">
            <div class="col-3">
              <span class="form_field"> Order Status :</span>
            </div>
            <div class="col-3">
              <span class="order_con_value">{{
                placedOrderDetails?.status === "WAITING_FOR_APPROVAL"
                  ? "Approval Pending"
                  : placedOrderDetails?.status_display
              }}</span>
            </div>
          </div>
          <div class="text-right custom_button mt-3">
            <p-button
              label="Order List"
              (click)="goToOrdersPage(placedOrderDetails)"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showBulkEstamp">
    <div class="row">
      <div class="col-lg-6 col-sm-6 col-md-6">
        <p class="nav_link_cat ms-1" style="margin-top: 30px">
          <span class="clickable" (click)="back()">Dashboard</span>
          <span [style.font-weight]="'bold'"> >> </span>
          <span>Automated Bulk Upload</span>
        </p>
      </div>
    </div>
    <div class="card mt-5 card_style_bs_order_cat">
      <div class="card-body p-4">
        <h5 class="card-title title_header_0">
          Complete Your Process in Just 3 Easy Steps
        </h5>
        <div class="d-flex">
          <ul class="row steps_style box_cat_upload">
            <li
              [ngClass]="[
                active_product ? 'box-item_active' : '',
                showUploadDocuments ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              1. Upload excel
            </li>

            <li
              [ngClass]="[
                active_sign ? 'box-item_active' : '',
                showSignDetails ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              2. Upload documents
            </li>

            <li
              [ngClass]="[
                active_confirm ? 'box-item_active' : '',
                showConfirmation ? 'boxOutline' : 'box-item'
              ]"
              class="col-lg-2 col-md-2 col-sm-3 col-4 clickable"
            >
              3. Order confirmation
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <div class="card card-body">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-md-6">
            <h5 class="title_five">Order Confirmation</h5>
            <div style="margin-top: 1rem">
              <div>
                <ul class="order_con">
                  <li>
                    <span class="bullet"></span>Your order request has been
                    placed <span class="order_bold">successfully!</span>
                  </li>
                  <li>
                    <span class="bullet"></span>Once completed, you will receive
                    an email confirmation.
                  </li>
                  <li>
                    <span class="bullet"></span> You can download the final
                    document from the order details page once it is completed.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="col-lg-1 col-sm-1 col-md-1 vertical_style"></div>
          <div class="col-lg-6 col-sm-6 col-md-6">
            <div class="row">
              <h5 class="card-title title_header_0">Order Details:</h5>
            </div>

            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">UUID :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">{{
                  placedOrderDetails?.bulk_order_uuid
                }}</span>
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Client ID :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">{{
                  placedOrderDetails?.client_id
                }}</span>
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Service :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">{{ getServiceTypeLabel() }}</span>
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Date :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">{{
                  placedOrderDetails?.created_at | date
                }}</span>
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Total Files :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">{{
                  placedOrderDetails?.total_files
                }}</span>
              </div>
            </div>
            <div class="flex_row">
              <div class="col-3">
                <span class="form_field">Order Status :</span>
              </div>
              <div class="col-6">
                <span class="order_con_value">
                  {{
                    placedOrderDetails?.status === "WAITING_FOR_APPROVAL"
                      ? "Approval Pending"
                      : placedOrderDetails?.status
                  }}
                </span>
              </div>
            </div>
            <div class="text-right custom_button mt-3">
            <p-button
              label="Order List"
              (click)="goToOrdersPage(placedOrderDetails)"
              styleClass="p-button-sm-outline"
            ></p-button>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
